
            const data = {"name":"calendar","data":{"width":"18","height":"19","viewBox":"0 0 18 19","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.25 2.75V5h1.5V2.75h6.5V5h1.5V2.75h2.5v14.5H1.75V2.75h2.5zm1.5-1.5h6.5V0h1.5v1.25h4v17.5H.25V1.25h4V0h1.5v1.25zM10 8h3v3h-3V8z\" _fill=\"#1A1A1A\"/>"}}
        
                module.exports = data
                